<template>
  <div class="sheet-pagination">
    <button
      class="sheet-pagination__button"
      @click="prevSheet"
      :disabled="isFirstSheet"
    >
      <span class="sheet-pagination__button--icon sheet-pagination__button--icon--left">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
          <path d="M7.00024 1.33984L1.00024 7.33984L7.00024 13.3398" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="sheet-pagination__button--text">
        Prev
      </span>
    </button>

    <div class="sheet-pagination__table-info">
      <span class="sheet-pagination__table-info--text">
        {{ currentSurface + 1 }} 
      </span>
      <span class="sheet-pagination__table-info--text">
        of
      </span>
      <span class="sheet-pagination__table-info--text">
        {{ surfaceCount }}
      </span>
    </div>

    <button
      class="sheet-pagination__button"
      @click="nextSheet"
      :disabled="isLastSheet"
    >
      <span class="sheet-pagination__button--text">
        Next
      </span>
      <span class="sheet-pagination__button--icon sheet-pagination__button--icon--right">
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
          <path d="M1.00024 1.33984L7.00024 7.33984L1.00024 13.3398" stroke="#ADADAD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { E_SHEET_PAGINATION_EVENT } from '../../types/components-events.enums';
import type { TSheetPaginationEventResponse } from '../../types/event-response.types';

interface IProps {
  currentSurface: number;
  surfaceCount: number;
};
const props = defineProps<IProps>();
const emit = defineEmits<{
  (event: E_SHEET_PAGINATION_EVENT.PREV, payload: TSheetPaginationEventResponse[E_SHEET_PAGINATION_EVENT.PREV]): void;
  (event: E_SHEET_PAGINATION_EVENT.NEXT, payload: TSheetPaginationEventResponse[E_SHEET_PAGINATION_EVENT.NEXT]): void;
}>();

const isFirstSheet = computed(() => props.currentSurface === 0);
const isLastSheet = computed(() => props.currentSurface === props.surfaceCount - 1);

function prevSheet() {
  emit(E_SHEET_PAGINATION_EVENT.PREV);
}

function nextSheet() {
  emit(E_SHEET_PAGINATION_EVENT.NEXT);
}
</script>

<style scoped lang="scss">
.sheet-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  &__button {
    display: flex;
    align-items: center;
    gap: 8px;
    color: $brand-color;
    padding: 8px 12px;
    background: none;
    border: none;
    cursor: pointer;

    &--text {
      text-align: center;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
    }

    &--icon {
      display: flex;
      align-items: center;
      justify-content: center;
      * {
        stroke: $brand-color!important;
      }
    }

    &:disabled {
      color: #ADADAD;
      cursor: default;
      
      * {
        stroke: #ADADAD!important;
      }
    }
  }

  &__table-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    &--text {
      color: #282828;
      text-align: center;
      font-family: 'Inter', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>